document.addEventListener('DOMContentLoaded', function() {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function initMobileAccordion() {
    if (!isMobile()) return;

    const accordionLabels = document.querySelectorAll('.accordion__label');
    
    accordionLabels.forEach(label => {
      const content = label.nextElementSibling;
      const item = label.parentNode;
      
      if (content && content.classList.contains('accordion__content')) {
        content.style.display = 'none';
        content.setAttribute('aria-hidden', 'true');
        content.style.height = '0';
        content.style.overflow = 'hidden';
      }
      if (label) {
        label.setAttribute('aria-expanded', 'false');
      }
      if (item) {
        item.setAttribute('data-open', 'false');
      }
    });


    accordionLabels.forEach(label => {
      const newLabel = label.cloneNode(true);
      label.parentNode.replaceChild(newLabel, label);
    });

    
    const freshLabels = document.querySelectorAll('.accordion__label');
    
    freshLabels.forEach(label => {
      label.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const content = this.nextElementSibling;
        const item = this.parentNode;
        
        if (!content || !content.classList.contains('accordion__content')) return;

        const isOpen = content.style.display === 'block' || 
                      content.offsetHeight > 0 ||
                      content.getAttribute('aria-hidden') === 'false';

        if (isOpen) {
          // Fecha
          content.style.display = 'none';
          content.style.height = '0';
          content.style.overflow = 'hidden';
          content.setAttribute('aria-hidden', 'true');
          this.setAttribute('aria-expanded', 'false');
          if (item) item.setAttribute('data-open', 'false');
        } else {
          // Abre
          content.style.display = 'block';
          content.style.height = 'auto';
          content.setAttribute('aria-hidden', 'false');
          this.setAttribute('aria-expanded', 'true');
          if (item) item.setAttribute('data-open', 'true');
        }
      }, true);
    });
  }

  initMobileAccordion();
  
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMobileAccordion, 250);
  });
});